import { Skeleton as MuiSkeleton, SxProps, Theme } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { SkeletonBaseProps, SKELETON_ANIMATION } from './Skeleton.types';
import { getSkeletonBackgroundColor, getSkeletonBorderRadius } from './styleUtils';
import { SkeletonText } from './compositions/SkeletonText';
import { SkeletonBox } from './compositions/SkeletonBox';
import { SkeletonCircle } from './compositions/SkeletonCircle';
import { SkeletonField } from './compositions/SkeletonField';
import { TableSkeleton } from './compositions/TableSkeleton';
import { FormSkeleton } from './compositions/FormSkeleton';
import { ParagraphSkeleton } from './compositions/ParagraphSkeleton';
import { SessionSkeleton } from './compositions/SessionSkeleton';
import { CardSkeleton } from './compositions/CardSkeleton';
import { RowSkeleton, ClientSkeleton } from './compositions/RowSkeleton';
import { ListSkeleton } from './compositions/ListSkeleton';

type SkeletonProps = SkeletonBaseProps & {
    variant?: 'text' | 'rectangular' | 'rounded' | 'circular';
    width?: string | number;
    height?: string | number;
};

const SkeletonBase = ({ variant = 'rounded', width, height, sx }: SkeletonProps) => {
    const theme = useTheme();

    const baseStyles: SxProps<Theme> = {
        backgroundColor: getSkeletonBackgroundColor(theme),
        ...(variant === 'rounded' && {
            borderRadius: getSkeletonBorderRadius(theme),
        }),
        ...sx,
    };

    return (
        <MuiSkeleton
            variant={variant}
            width={width}
            height={height}
            animation={SKELETON_ANIMATION}
            sx={baseStyles}
        />
    );
};

export const Skeleton = Object.assign(SkeletonBase, {
    Text: SkeletonText,
    Box: SkeletonBox,
    Circle: SkeletonCircle,
    Field: SkeletonField,
    Table: TableSkeleton,
    Form: FormSkeleton,
    Paragraph: ParagraphSkeleton,
    Session: SessionSkeleton,
    Card: CardSkeleton,
    Row: RowSkeleton,
    Client: ClientSkeleton,
    List: ListSkeleton,
});
